import type { FC } from "react";
import { useMutation } from "@tanstack/react-query";
import Box from "@mui/material/Box";
import { Translate, useTranslation } from "@privacy/translations";
import { removeCustomerLibraryProcessingFromOrganisationMutationOptions } from "../api/registrations";
import type { RegistrationById } from "../api/registrations.types";
import { ActionMenuDeleteMenuItem } from "../shared/ActionMenu";
import { usePermission } from "../shared/permissions";

export const RemoveFromRegisterMenuItem: FC<{
  registration: RegistrationById;
  onClose: () => void;
  onRemoved: () => void;
}> = ({ registration, onClose, onRemoved }) => {
  const { t } = useTranslation();
  const { hasPermission } = usePermission();
  const removeFromRegisterMutation = useMutation(removeCustomerLibraryProcessingFromOrganisationMutationOptions());

  return (
    <ActionMenuDeleteMenuItem
      label={t("RegistrationDrawer.RemoveFromRegister.Label")}
      missingPermission={!hasPermission("nova-forms-api:registration:delete", registration.permissions)}
      confirmDeleteDialog={{
        header: t("RegistrationDrawer.RemoveFromRegister.ConfirmHeader"),
        message: (
          <Translate
            translationKey="RegistrationDrawer.RemoveFromRegister.ConfirmMessage"
            values={{
              name: (
                <Box component="span" key={registration.name} sx={{ fontWeight: "bold" }}>
                  {registration.name}
                </Box>
              ),
              customer: (
                <Box component="span" sx={{ fontWeight: "bold" }}>
                  {registration.organisationEditability?.managedBy?.name}
                </Box>
              ),
            }}
          />
        ),
        delete: t("RegistrationDrawer.RemoveFromRegister.Confirm"),
      }}
      onClose={onClose}
      onDelete={() => removeFromRegisterMutation.mutateAsync(registration.id, { onSuccess: onRemoved })}
    />
  );
};
